const API_BASE = import.meta.env.VITE_API_BASE || '';

export async function apiGet(path, params = {}) {
  const q = new URLSearchParams(params);
  const fullPath = `${API_BASE}${path}`;
  const url = q.toString() ? `${fullPath}?${q}` : fullPath;
  const res = await fetch(url, { headers: { Accept: 'application/json' } });
  const text = await res.text();
  let data;
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    const t = text.trim();
    const hint = t.startsWith('<')
      ? ' The server returned HTML (wrong URL or dev proxy target down). For local dev run `npm run worker:dev` on port 8787 so Vite can proxy /api.'
      : t
        ? ` Body: ${t.slice(0, 160)}${t.length > 160 ? '…' : ''}`
        : ' Empty response.';
    throw new Error(`Invalid JSON from ${path}.${hint}`);
  }
  if (!res.ok) {
    const err = new Error(data.error || res.statusText || 'Request failed');
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export async function apiPost(path, body) {
  const res = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.error || res.statusText || 'Request failed');
    err.status = res.status;
    throw err;
  }
  return data;
}
